export const getSavedSearchIndexPath = state => state.paths.propertySearches;
export const duplicatePropertiesPath = state => state.paths.propertyDuplicates;
